import posthog from 'posthog-js'
import { captureAttribution, getStoredAttribution } from './src/lib/utm'
import { AB_ARM_PROPERTY, parseAbArm } from './src/lib/ab-arm'

const redactReportCredentials = (value) => {
  if (typeof value !== 'string') return value

  try {
    const url = new URL(value, window.location.origin)
    url.searchParams.delete('session_id')
    url.searchParams.delete('t')
    return url.toString()
  } catch {
    return value
  }
}

posthog.init(process.env.NEXT_PUBLIC_POSTHOG_KEY, {
  api_host: process.env.NEXT_PUBLIC_POSTHOG_HOST,
  
  // Person profiles configuration
  person_profiles: 'identified_only',
  
  // Feature flag configuration
  feature_flag_request_timeout_ms: 3000, // 3 seconds timeout for feature flags
  
  // Enable autocapture for better metadata collection
  autocapture: true,
  capture_pageview: true,
  capture_pageleave: true,
  
  // Exception tracking configuration (PostHog automatically captures metadata)
  capture_exceptions: true,
  capture_dead_clicks: true,
  capture_rage_clicks: true,
  enable_recording_console_log: true,
  
  // Session recording settings
  session_recording: {
    maskAllInputs: true,
    maskTextSelector: '.posthog-mask-sensitive',
  },
  
  // Process events before sending (PostHog's recommended approach)
  before_send: (event) => {
    if (!event) return event
    if (event.properties) {
      for (const property of ['$current_url', '$referrer', '$session_entry_url']) {
        event.properties[property] = redactReportCredentials(event.properties[property])
      }
    }

    const version = process.env.NEXT_PUBLIC_APP_VERSION || 'unknown'
    event.properties = {
      ...event.properties,
      app: 'minitools',
      $app_namespace: 'minitools',
      app_version: version,
      $app_version: version,
      environment: process.env.NODE_ENV || 'production',
    }
    return event;
  },
  
  // Loaded callback for debugging
  loaded: (posthog) => {
    if (process.env.NODE_ENV === 'development') {
      console.log('PostHog loaded successfully');
      // Enable debug mode in development to see all captured properties
      posthog.debug();
    }
    // Capture UTMs / referrer on first page load
    captureAttribution();

    // Blog CTA split test: carry the arm on every later event in this browser.
    const abArm = parseAbArm(getStoredAttribution()?.utm_term);
    if (abArm) {
      posthog.register({ [AB_ARM_PROPERTY]: abArm });
    }
  }
})
